<template>
    <v-container class="pa-0 ma-0" fluid>
      <v-row class="mb-0 pb-0">
        <v-col cols="10" md="6">
            <v-text-field
              label=""
              placeholder="Buscar..."
              @keyup.enter="search()"
              filled
              dense
              hide-details
              class="caption"
              ref="fieldSearch"
            ></v-text-field>
        </v-col>
        <v-col cols="2" md="6" class="my-2">
          <v-btn  tile medium color="primary" icon @click.prevent="search()">
            <v-icon medium>fa-search</v-icon>
          </v-btn>          
        </v-col>
      </v-row>
			<v-row class="px-0 py-0">
				<v-col cols=12 >
          <v-data-table
            dense
            :headers="headers"
            :items="filtro"
            class="elevation-2"
            :hide-default-header="false"
            min-height="200px"
            height="320px"

            
            :fixed-header="true"

            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"

            :disable-pagination='false'
            :loading="loadGrid"
           
            :mobile-breakpoint=100
          >
            <template v-slot:top>
              <v-toolbar flat dense color="white">
                <v-dialog v-model="dialog" max-width="640px"  scrollable persistent>
                  <template v-slot:activator="{ on }">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" v-on="on">+</v-btn>
                  </template>
                  <v-card>
                    <!--
                    <v-card-title>
                      <span class="headline">ABM</span>
                    </v-card-title>
                    -->
                    <v-toolbar dense flat dark color="primary" class="mb-2">
                      <v-toolbar-title class="body-2">{{ formTitle }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                      <v-btn x-small icon @click="dialog=!dialog">
                        <v-icon>fa fa-close</v-icon>
                      </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" lg="4">
                            <v-text-field v-model="editedItem.id" label="ID" disabled class="caption"></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="12">
                            <v-text-field v-model="editedItem.des" label="Marca" class="caption"></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="12">
                            <v-text-field v-model="editedItem.icono" label="Icono" disabled class="caption"></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="12">
                            <v-checkbox v-model="editedItem.estado" hide-details class="body-2 py-2 my-0">
                              <template v-slot:label>
                                <span class="caption">Habilitado</span>
                              </template>  
                            </v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary darken-1" text @click="close">Cancelar</v-btn>
                      <v-btn color="primary darken-1" text @click="save" :loading="send" :disabled="!editedItem.des?true:false">Aceptar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item="{item,isSelected,select,headers} ">
              <tr class="body-2">
                <template v-for="(h, idx) in headers" >
                  <td v-if="h.value=='estado'"  :align="h.align" :key="idx" :class="['caption', h.class]"> 
                    <v-simple-checkbox dense :value="item[h.value]?true:false" disabled></v-simple-checkbox>
                  </td>
                  <td v-else-if="h.value=='actions'" :align="h.align" :key="idx" :class="[ h.class]" class="px-1">
                    <v-icon
                      small
                      class="mx-3"
                      @click="editItem(item)"
                    >
                      fa fa-pencil
                    </v-icon>
                    <v-icon
                      small
                      class="mx-3"
                      @click="deleteItem(item)"
                    >
                      fa fa-trash-o
                    </v-icon>
                  </td>
                  <td v-else :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                </template>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols=12>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </v-col>

      </v-row>
    </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'MarcasAutos',

    components: {
      
    },

    data: () => ({
      msgs:[{action:"del",msg:"Seguro que desea eliminar el auto seleccionado?" }],

      fieldSearch:"",

      loadGrid:false,

      headers: [
        { text: 'ID',align: 'start',sortable: false, value: 'id',width:"120px", class:"d-none"},
        { text: 'Marca' ,align: 'start',sortable: true, value: 'des', class:"text-truncate"},
        { text: 'Estado', align: 'center', sortable:false, value: 'estado', width:"85px"},
        { text: ''       ,align: 'center'  ,sortable: false, value: 'actions', width:"85px" },
      ],
      items:[],

      //dialog

      dialog:false,

      send:false,
      
      editedIndex: -1,
      editedItem: {
      
      },
      defaultItem: {},
      //dialog



      page: 1,
      pageCount: 0,
      itemsPerPage: 100,


    }),
    created: function () {
      console.log("Componente creado")
      this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
      this.loadItems()
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      initialize () {},

      search(){
        this.fieldSearch=this.$refs.fieldSearch.$refs.input.value
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        confirm('Seguro que desea eliminar el auto seleccionado?') && this.delete(item.id)

        //por ahora no hace nada
      },

      close () {
        this.dialog = false
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      },

      async delete(id) {
        let opt={
          method: 'DELETE', 
          mode: 'cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },  
          //body: JSON.stringify(param),
        }
        let response = await fetch(`${this.ROOT_API}cms/autos/marcas/${id}`, opt)
        
        await this.loadItems()
      },

      async save () {
        this.send=true

        let param={id:this.editedItem.id||0,des: this.editedItem.des||'', estado:this.editedItem.estado||0}

        console.log(param)

        if (this.editedIndex > -1) {
          //UPDATE
            let opt={
            method: 'PUT', 
            mode: 'cors',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },  
            body: JSON.stringify(param),
          }
          let response = await fetch(`${this.ROOT_API}cms/autos/marcas/${this.editedItem.id}`, opt);
        } else {
          //INSERT
          let opt={
            method: 'POST', 
            mode: 'cors',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },  
            body: JSON.stringify(param),
          }
          let response = await fetch(`${this.ROOT_API}cms/autos/marcas`, opt);
        }

        await this.loadItems()
        this.send=false
        this.close()
      },



      async loadItems (){
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}autos/marcas`, opt);

        if (response.ok){
          let r=await response.json()
          this.items=r.map(item => {
            return {
              id:item.id,
              des:item.descripcion.toUpperCase(),
              icono:item.icono,
              estado:item.estado,
            }
          })
        }

      }


    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Marca de Auto' : 'Editar Marca de Auto'
      },

      filtro: function(){
        this.loadGrid=true
        let r//=this.items

        //console.log(this.fieldSearch.toLowerCase())

        r=this.items.filter( item => item.des.toUpperCase().includes(this.fieldSearch.toUpperCase()))
        this.loadGrid=false
        return r//((r && r.length>0)  ? r.map(function(i) { return parseFloat(i.importe) }).reduce((res, item) => res=res + item) : 0).toFixed(2)
      },
    },
  }
</script>

<style scoped>

</style>
